import { graphql } from "gatsby"
import React from "react"
import Banner from "../components/Banner"
import CampExpandingSlider from "../components/CampExpandingSlider"
import CampListing from "../components/CampListing"
import DestinationsListing from "../components/DestinationsListing"
import ExperienceListing from "../components/ExperienceListing"
import FullImageWithMap from "../components/FullImageWithMap"
import FullwidthImageWithContent from "../components/FullwidthImageWithContent"
import GallerySlider from "../components/GallerySlider"
import GetInTouch from "../components/GetInTouch"
import ImageWithContent from "../components/ImageWithContent"
import IntroductionContent from "../components/IntroductionContent"
import ItinerariesListing from "../components/ItinerariesListing"
import ItinerariesListingGrid from "../components/ItinerariesListingGrid"
import ItinerariesSlider from "../components/ItinerariesSlider"
import MapImage from "../components/MapImage"
import OfferListing from "../components/OfferListing"
import RelatedCards from "../components/RelatedCards"
import Testimonials from "../components/Testimonials"
import IconGrid from "../components/IconGrid"
import BlogSlider from "../components/BlogSlider"
import SliderWithContent from "../components/SliderWithContent"
import VideoWithContent from "../components/VideoWithContent"
import Faq from "../components/Faq"
import ContactInfo from "../components/ContactInfo"
import LegalContent from "../components/LegalContent"
import ProjectGrid from "../components/ProjectGrid"
import BlogListing from "../components/BlogListing"
import GalleryGrid from "../components/GalleryGrid"
import Gallery from "../components/Gallery"
import LiveAvailability from "../components/LiveAvailability"
import ExperienceListingSlider from "../components/ExperienceListingSlider"

const Main = props => {
  const modules = props.modules.pageContent
  const { location } = props

  const components = {
    Banner: Banner,
    IntroductionContent: IntroductionContent,
    CampExpandingSlider: CampExpandingSlider,
    FullImageWithMap: FullImageWithMap,
    GallerySlider: GallerySlider,
    ItinerariesListingGrid: ItinerariesListingGrid,
    ImageWithContent: ImageWithContent,
    Testimonials: Testimonials,
    MapImage: MapImage,
    FullwidthImageWithContent: FullwidthImageWithContent,
    RelatedCards: RelatedCards,
    ItinerariesListing: ItinerariesListing,
    CampListing: CampListing,
    ExperienceListing: ExperienceListing,
    ItinerariesSlider: ItinerariesSlider,
    OfferListing: OfferListing,
    DestinationsListing: DestinationsListing,
    GetInTouch: GetInTouch,
    IconGrid: IconGrid,
    BlogSlider: BlogSlider,
    SliderWithContent: SliderWithContent,
    VideoWithContent: VideoWithContent,
    Faq: Faq,
    ContactInfo: ContactInfo,
    LegalContent: LegalContent,
    ProjectGrid: ProjectGrid,
    BlogListing: BlogListing,
    GalleryGrid: GalleryGrid,
    Gallery: Gallery,
    LiveAvailability: LiveAvailability,
    ExperienceListingSlider: ExperienceListingSlider,
  }

  return (
    <>
      {modules
        ? modules.map((module, i) => {
            const moduleName = module.__typename.replace(
              "WpPage_Pagecontent_PageContent_",
              ""
            )
            return (
              components[moduleName] &&
              React.createElement(components[moduleName], {
                key: i,
                module,
                location,
                i,
              })
            )
          })
        : null}
    </>
  )
}

export default Main

export const MainFragment = graphql`
  fragment MainFragment on WpPage {
    pageContent {
      pageContent {
        __typename
        ...PageBannerFragment
        ...PageIntroductionContentFragment
        ...PageCampExpandingSliderFragment
        ...PageFullImageWithMapFragment
        ...PageGallerySliderFragment
        ...PageItinerariesListingGridFragment
        ...PageImageWithContentFragment
        ...PageTestimonialsFragment
        ...PageMapImageFragment
        ...PageFullwidthImageWithContentFragment
        ...PageRelatedCardsFragment
        ...PageItinerariesListingFragment
        ...PageExperienceListingFragment
        ...PageItinerariesSliderFragment
        ...PageCampListingFragment
        ...PageOfferListingFragment
        ...PageDestinationsListingFragment
        ...PageGetInTouchFragment
        ...PageIconGridFragment
        ...PageBlogSliderFragment
        ...PageSliderWithContentFragment
        ...PageVideoWithContentFragment
        ...PageFaqFragment
        ...PageContactInfoFragment
        ...PageLegalContentFragment
        ...PageProjectGridFragment
        ...PageBlogListingFragment
        ...PageGalleryGridFragment
        ...PageGalleryFragment
        ...PageLiveAvailabilityFragment
        ...PageExperienceListingSliderFragment
      }
    }
  }
`
